<template>
<div style="width:100%; padding-top: 60px">
  <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
    <div style="text-align:center">
      <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
      <screenButton class="screenButton"></screenButton>
    </div>
  </div>

  <b-table class="bgc-dark" head-variant="dark" responsive bordered
           :items="items" :fields="fields1">
    <template v-slot:head()="scope">
      <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
        {{ scope.label }}
      </div>
    </template>
    <template v-slot:cell(num)="data">
      {{ Number(data.item.num).toFixed(4) }}
    </template>
    <template v-slot:cell(price)="data">
      {{ Number(data.item.price).toFixed(4) }}
    </template>
    <template v-slot:cell(amount)="data">
      {{ Number(data.item.amount).toFixed(2) }}
    </template>

    <template v-slot:table-colgroup="scope">
      <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{ width: field.width }"
      >
    </template>
  </b-table>
</div>
</template>

<script>
export default {
  name: "vatInvoiceDetail",
  data(){
    return {
      fields1: [
        {key: 'detailno', label: '项目编码', width: '60px'},
        {key: 'name', label: '项目名称', width: '120px'},
        {key: 'unit', label: '单位', width: '100px'},
        {key: 'num', label: '数量', width: '100px'},
        {key: 'price', label: '标准', width: '100px'},
        {key: 'amount', label: '金额（元）', width: '130px'},
      ],
      items: [],
    }
  },
  created(){
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    goBack(){
      this.$router.back()
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>
